export default  function somataorio(valores: number[]){
    try {
     const num =  valores.reduce((total, valor) => total + Number(valor), 0)
     return num.toString()
    } catch (error: any) {

    }
}